import { z } from "zod";

export const WebhookControllerResponseSchema = {
  handleDocusealWebhook: z.void(),
};
